import type { PropsWithChildren } from "react";

import { graphql, useFragment } from "react-relay";

import { PageWithBreadCrumbs } from "app/components/layout/PageWithBreadCrumbs";
import { useSettingsBreadcrumbs } from "app/hooks/routing/useSettingsBreadcrumbs";

import { type AccessControlSettingsPage_query$key } from "./__generated__/AccessControlSettingsPage_query.graphql";

interface Props extends PropsWithChildren {
  queryRef: AccessControlSettingsPage_query$key;
  pageTitle?: string;
  /** Whether to wrap the page content in a card-like Paper */
  withPaper?: boolean;
}

export function AccessControlSettingsPage({
  queryRef,
  pageTitle,
  children,
  withPaper,
}: Props) {
  const data = useFragment(
    graphql`
      fragment AccessControlSettingsPage_query on Query {
        ...PageWithBreadCrumbs_query
      }
    `,
    queryRef,
  );

  const breadcrumbs = useSettingsBreadcrumbs();

  return (
    <PageWithBreadCrumbs
      breadcrumbs={breadcrumbs}
      defaultTitle="Settings"
      queryRef={data}
      title={pageTitle ?? "Access Control"}
      withPaper={withPaper}
    >
      {children}
    </PageWithBreadCrumbs>
  );
}
